import { render, staticRenderFns } from "./personProject.vue?vue&type=template&id=01b3e760&scoped=true"
import script from "./personProject.vue?vue&type=script&lang=js"
export * from "./personProject.vue?vue&type=script&lang=js"
import style0 from "./personProject.vue?vue&type=style&index=0&id=01b3e760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3e760",
  null
  
)

export default component.exports